class Utils {
   onDocumentReady = function(fn) {
    if (document.readyState !== 'loading') {
      fn()
    }
    else {
      document.addEventListener('DOMContentLoaded', fn)
    }
  }

  onElementReady(selector, fn) {
     this.onDocumentReady(() => {
       document.querySelectorAll(selector).forEach(el => {
         fn(el)
       })
     })
  }

  onElementArrive(selector, fn) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
        if (document.querySelector(selector)) {
          observer.disconnect();
          resolve(document.querySelector(selector));
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }).then(el => fn(el));
  }

}


export default new Utils()
